import React, { useMemo, useState } from "react";
import "./App.css";
import packageJson from '../package.json';
import aaLogo from "./assets/aa-logo.png";

import HomePage from "./HomePage";
import MesurePage from "./MesurePage";
import ArchivesPage from "./ArchivesPage";
import ThicknessPage from "./ThicknessPage";
import TestsPage from "./TestsPage";
import ReadingTestPage from "./ReadingTestPage";
import IshiharaTestPage from "./IshiharaTestPage";
import ManualThicknessTestPage from "./ManualThicknessTestPage";
import Footer from "./Footer";

import LockScreen, { STORAGE_KEY } from "./LockScreen";

function InfosPage({ goTo }) {
  return (
    <div className="App">
      <h1>Infos (en construction)</h1>
      <button onClick={() => goTo("home")}>⬅ Retour</button>
      <div style={{
        position: "fixed",
        bottom: 5,
        right: 10,
        fontSize: "12px",
        color: "#888"
      }}>
        Version {packageJson.version}
      </div>
    </div>
  );
}


function StoreSessionBar() {
  const [store, setStore] = React.useState(null);

  React.useEffect(() => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return;

    try {
      const parsed = JSON.parse(data);
      setStore(parsed);
    } catch {}
  }, []);

  const handleLogout = () => {
    localStorage.removeItem(STORAGE_KEY);
    window.location.reload();
  };

  if (!store) return null;

  return (
    <div className="store-session-bar">
      <div className="store-info">
  <img src={aaLogo} alt="AA" className="store-logo" />
  <span className="store-name">{store.storeName}</span>
</div>
      <span className="separator">|</span>
      <button className="logout-btn" onClick={handleLogout}>
        Déconnexion
      </button>
    </div>
  );
}

export default function App() {
  const [currentPage, setCurrentPage] = useState("home");
  const [pageData, setPageData] = useState(null);

  const [isUnlocked, setIsUnlocked] = useState(() => {
  const savedSession = localStorage.getItem(STORAGE_KEY);
  if (!savedSession) return false;

  try {
    const parsed = JSON.parse(savedSession);
    return parsed?.unlocked === true;
  } catch {
    return false;
  }
});

  const goTo = (page, data = null) => {
    setPageData(data);
    setCurrentPage(page);
  };

  const onUnlocked = () => setIsUnlocked(true);

  const appContent = useMemo(() => {
    return (
      <>
        {currentPage === "home" && <HomePage goTo={goTo} />}
        {currentPage === "mesures" && <MesurePage goTo={goTo} data={pageData} />}
        {currentPage === "thickness" && <ThicknessPage goTo={goTo} data={pageData} />}
        {currentPage === "tests" && <TestsPage goTo={goTo} />}
        {currentPage === "reading-test" && <ReadingTestPage goTo={goTo} />}
        {currentPage === "ishihara-test" && <IshiharaTestPage goTo={goTo} />}
        {currentPage === "manual-thickness-test" && <ManualThicknessTestPage goTo={goTo} />}
        {currentPage === "infos" && <InfosPage goTo={goTo} />}
        {currentPage === "archives" && <ArchivesPage goTo={goTo} />}

        <Footer />
      </>
    );
  }, [currentPage, pageData]);

  return isUnlocked ? (
  <>
    <StoreSessionBar />

    {appContent}

    <div style={{
      position: "fixed",
      bottom: 5,
      right: 10,
      fontSize: "12px",
      color: "#888"
    }}>
      iScan  V {packageJson.version}
    </div>

  </>
) : (
  <LockScreen onUnlocked={onUnlocked} />
);
}
